var ProductReviews, formatButtons, formatHelpfulText, processUserReview, ref,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

ProductReviews = window.ProductReviews != null ? window.ProductReviews : window.ProductReviews = {};

if (ProductReviews.Views == null) {
  ProductReviews.Views = {};
}

if (window.moment == null) {
  window.moment = require('../../../../node_modules/moment/moment.js');
}

ProductReviews.Views.UserReview = require('../views/product_reviews_user_review');

ref = require('../../common/helpers'), formatButtons = ref.formatButtons, formatHelpfulText = ref.formatHelpfulText, processUserReview = ref.processUserReview;

ProductReviews.Model = Backbone.Model.extend({
  maximumReviewTextHeight: 109,
  defaultTimeout: 3000,
  idAttribute: 'uuid',
  defaults: {
    rating: 0,
    reviewTextHeight: 0
  },
  initialize: function(attrs, options) {
    _.extend(this, options);
    if (this.dealUuid == null) {
      this.dealUuid = attrs != null ? attrs.dealUuid : void 0;
    }
    _.bindAll(this, 'reviewSuccess', 'reviewError', 'upvoteSuccess', 'upvoteError', 'unvoteSuccess', 'unvoteError', 'downvoteSuccess', 'downvoteError', 'deleteSuccess', 'deleteError');
    return this.set({
      locale: I18n.locale,
      userVote: this.getUserVote()
    });
  },
  getUserVote: function() {
    var ref1, userDownvotedReviews, userUpvotedReviews, uuid;
    if (this.displayOptions) {
      ref1 = this.displayOptions, userUpvotedReviews = ref1.userUpvotedReviews, userDownvotedReviews = ref1.userDownvotedReviews;
    }
    if (!((userUpvotedReviews != null ? userUpvotedReviews.length : void 0) || (userDownvotedReviews != null ? userDownvotedReviews.length : void 0))) {
      return;
    }
    uuid = this.get('uuid');
    if (indexOf.call(userUpvotedReviews, uuid) >= 0) {
      return 'upvoted';
    } else if (indexOf.call(userDownvotedReviews, uuid) >= 0) {
      return 'downvoted';
    }
  },
  url: function(action) {
    if (action == null) {
      action = '';
    }
    return this.rootUrl + "/product_review_proxy/reviews" + action + "?_csrf=" + this.csrf;
  },
  sync: function(method, model, options) {
    if (options == null) {
      options = {};
    }
    options.timeout = ProductReviews.timeout || this.defaultTimeout;
    return Backbone.Model.prototype.sync.call(this, method, model, options);
  },
  toJSON: function() {
    return {
      deal_uuid: this.dealUuid,
      option_uuid: this.get('uuid'),
      locale: this.get('locale'),
      rating: this.get('rating'),
      source: this.source,
      text: $.trim(this.get('text'))
    };
  },
  review: function() {
    return this.save(this.toJSON(), {
      type: 'POST',
      wait: true,
      success: this.reviewSuccess,
      error: this.reviewError,
      url: this.url()
    });
  },
  reviewSuccess: function(model, response) {
    var ref1, ref2;
    if (response.error != null) {
      return this.reviewError(model, response);
    }
    if ((ref1 = this.displayOptions) != null) {
      ref1.userReviewIds.push(response.review.uuid);
    }
    this.set(processUserReview(response.review, this.displayOptions, I18n, moment));
    this.view.showReviewSuccess(new ProductReviews.Views.UserReview({
      model: this,
      el: this.view.userReviewEl
    }));
    if ((ref2 = this.displayOptions) != null ? ref2.readMoreEnabled : void 0) {
      return this.updateReadMore();
    }
  },
  reviewError: function(model, response) {
    return this.view.showReviewError();
  },
  upvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.upvoteSuccess,
      error: this.upvoteError,
      url: this.url("/" + this.id + "/upvote")
    });
  },
  upvoteSuccess: function(model, response) {
    var reviewMeta, upvoteCount;
    upvoteCount = this.get('upvoteCount') + 1;
    reviewMeta = {
      upvoteCount: upvoteCount,
      placement: this.get('placement'),
      uuid: this.get('uuid')
    };
    this.set({
      userVote: 'upvoted',
      upvoteCount: upvoteCount,
      helpfulUpvote: {
        buttonInfo: formatButtons(reviewMeta, true, this.displayOptions, I18n),
        text: formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      }
    });
    this.collection.recordUpvote(this.id);
    return this.view.showVoteSuccess(this);
  },
  upvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.upvoteSuccess(model, response);
    }
    return this.view.showVoteError(this);
  },
  isDuplicateError: function(response) {
    return (response.readyState === 4) && (response.status === 409);
  },
  unvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.unvoteSuccess,
      error: this.unvoteError,
      url: this.url("/" + this.id + "/unvote")
    });
  },
  unvoteSuccess: function(model, response) {
    var downvoteCount, reviewMeta, upvoteCount;
    upvoteCount = this.get('upvoteCount') > 0 ? this.get('upvoteCount') - (this.get('userVote') === 'upvoted') : 0;
    downvoteCount = this.get('downvoteCount') > 0 ? this.get('downvoteCount') - (this.get('userVote') === 'downvoted') : 0;
    reviewMeta = {
      upvoteCount: upvoteCount,
      placement: this.get('placement'),
      uuid: this.get('uuid')
    };
    this.set({
      upvoteCount: upvoteCount,
      helpfulUpvote: {
        buttonInfo: formatButtons(reviewMeta, false, this.displayOptions, I18n),
        text: formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      },
      downvoteCount: downvoteCount
    });
    this.collection.recordUnvote(this.id);
    return this.view.showUnvoteSuccess(this);
  },
  unvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.unvoteSuccess(model, response);
    }
    return this.view.showUnvoteError(this);
  },
  downvote: function() {
    return this.save({}, {
      type: 'POST',
      wait: true,
      success: this.downvoteSuccess,
      error: this.downvoteError,
      url: this.url("/" + this.id + "/downvote")
    });
  },
  downvoteSuccess: function(model, response) {
    var downvoteCount, reviewMeta, upvoteCount;
    upvoteCount = this.get('upvoteCount');
    downvoteCount = this.get('downvoteCount') + 1;
    reviewMeta = {
      upvoteCount: upvoteCount,
      placement: this.get('placement'),
      uuid: this.get('uuid')
    };
    this.set({
      userVote: 'downvoted',
      helpfulUpvote: {
        buttonInfo: formatButtons(reviewMeta, true, this.displayOptions, I18n),
        text: formatHelpfulText(upvoteCount, this.displayOptions, I18n)
      },
      downvoteCount: downvoteCount
    });
    this.collection.recordDownvote(this.id);
    return this.view.showVoteSuccess(this);
  },
  downvoteError: function(model, response) {
    if (this.isDuplicateError(response)) {
      return this.downvoteSuccess(model, response);
    }
    return this.view.showVoteError(this);
  },
  "delete": function() {
    return this.destroy({
      wait: true,
      success: this.deleteSuccess,
      error: this.deleteError,
      url: this.url("/" + this.id)
    });
  },
  deleteSuccess: function(response) {
    return this.view.showDeleteSuccess(this);
  },
  deleteError: function(response) {
    return this.view.showDeleteError(this);
  },
  setReviewTextHeight: function() {
    var ref1, reviewText, reviewTextId;
    if (!(reviewTextId = (ref1 = this.get('reviewIds')) != null ? ref1.reviewText : void 0)) {
      return;
    }
    reviewText = $("#" + reviewTextId);
    reviewText.parent().removeClass('show');
    return this.set('reviewTextHeight', reviewText.height());
  },
  shouldShowReadMore: function() {
    return this.get('reviewTextHeight') > this.maximumReviewTextHeight;
  },
  updateReadMore: function(resetHeight) {
    if (resetHeight) {
      this.set('reviewTextHeight', 0, {
        silent: true
      });
    }
    if (!this.get('reviewTextHeight')) {
      return this.setReviewTextHeight();
    }
  }
});

module.exports = ProductReviews.Model;

//# sourceMappingURL=data:application/json;base64,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
